/**
 * src/App.tsx
 * =============================================================================
 * Componente raíz.
 *
 * Responsabilidades:
 *  1. Montar los proveedores globales:
 *       QueryClientProvider → cache de datos (React Query)
 *       AuthProvider        → sesión de Better Auth (cookie HTTP-only)
 *       RouterProvider      → rutas React Router
 *
 * El orden importa: AuthProvider va *por fuera* de RouterProvider para que los
 * guards de ruta (RequireAuth, PublicOnlyRoute) puedan leer el contexto.
 *
 * Tema: solo light. La infraestructura dark/system se eliminó en 2026-05-26
 * (decisión de simplicidad — la app es 100% claro). Si vuelve a interesar,
 * se restaura desde git.
 * =============================================================================
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { router } from '@/router'
import { AuthProvider } from '@/components/providers/AuthProvider'
import { ActiveSpaceProvider } from '@/components/providers/ActiveSpaceProvider'
import { AppErrorBoundary } from '@/components/providers/AppErrorBoundary'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
})

export function App() {
  return (
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ActiveSpaceProvider>
            <RouterProvider router={router} />
          </ActiveSpaceProvider>
        </AuthProvider>
      </QueryClientProvider>
    </AppErrorBoundary>
  )
}
